import { render, staticRenderFns } from "./new_item_select.vue?vue&type=template&id=3649f840&scoped=true&"
import script from "./new_item_select.vue?vue&type=script&lang=js&"
export * from "./new_item_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649f840",
  null
  
)

export default component.exports